<template>
    <div class="style-guide-tags-list">
        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Widget Redesign Tag:
        </div>
        <div class="flex items-center flex-wrap gap-3 mb-5">
            <RedesignTag
                v-for="(tag, index) in tags"
                :key="index"
                :color="tag.color"
                :animated="tag.animated"
                :outline="tag.outline"
                :border-color="tag.borderColor"
                :tag-content="tag.tagContent"
            />
        </div>

        <div class="text-primary-600 font-medium text-main-lg mb-2">
            Report Base Tag:
        </div>
        <div class="flex items-center gap-4">
            <ReportBaseTag
                label="Real Time Monitor"
            />
            <ReportBaseTag
                label="Real Time Monitor"
                disabled
            />
            <ReportBaseTag
                label="Real Time Monitor"
                border
                max-content="120"
            />
            <ReportBaseTag
                label="Real Time Monitor"
                border
                max-content="120"
                disabled
            />
            <ReportBaseTag
                label="Real Time Monitor"
                unstyled
                class="border border-primary bg-primary text-white rounded-md py-2 px-3"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import RedesignTag from '@/components/RedesignBaseComponents/RedesignTag.vue'
import ReportBaseTag from '@/modules/reports/components/ReportBaseTag.vue'

const tags = ref([
    {
        color: '#E39B08',
        fontSize: '11px',
        showInCard: false,
        backgroundColor: '#FFF8EA',
        borderColor: '',
        tagContent: [ {
            iconName: 'ZoomIn',
            text: '12:13'
        } ]
    },
    {
        color: '#FF4D4D',
        fontSize: '11px',
        borderColor: '',
        showInCard: true,
        backgroundColor: '#FFF1F1',
        tagContent: [ {
            iconName: 'Heart',
            text: '12:43'
        } ]
    },
    {
        color: 'green',
        fontSize: '11px',
        backgroundColor: 'transparent',
        showInCard: false,
        borderColor: 'green',
        tagContent: [ {
            iconName: 'Star',
            text: '90%'
        } ]
    },
    {
        color: '',
        fontSize: '11px',
        backgroundColor: '#F2F2F2',
        showInCard: true,
        borderColor: '',
        animated: true,
        tagContent: [
            {
                iconName: 'ZoomIn',
                text: '12:13'
            },
            {
                iconName: 'Heart',
                text: '10:43'
            }
        ]
    },
    {
        color: '',
        fontSize: '11px',
        backgroundColor: '#F2F2F2',
        showInCard: true,
        outline: true,
        borderColor: '',
        tagContent: [ { text: '12:13' } ]
    }
])
</script>
